
import { bootstrapApplication } from '@angular/platform-browser';
import { provideZonelessChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import './firebase'; // Initialize Supabase Client

import { AppComponent } from './app.component';
import { routes } from './routes';
import { TranslationService } from './services/translation.service';
import { CustomerAuthService } from './customer-portal/services/auth.service';
import { ThemeService } from './customer-portal/services/theme.service';
import { GlobalErrorHandler } from './services/error-handler.service';

// Factory function for APP_INITIALIZER
export function initializeTranslations(translationService: TranslationService) {
  return (): Promise<void> => translationService.init();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withHashLocation()), // Hash location is safer for Static Hosting
    provideHttpClient(),
    TranslationService,
    CustomerAuthService, 
    ThemeService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslationService],
      multi: true,
    },
    // Register Global Error Handler
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
}).catch(err => {
  console.error('Angular bootstrapping failed:', err);
  
  const errorContainer = document.getElementById('bootstrap-error');
  const errorMessageElement = document.getElementById('bootstrap-error-message');
  const appRoot = document.querySelector('app-root');

  if (appRoot) {
    (appRoot as HTMLElement).style.display = 'none';
  }
  
  if (errorContainer && errorMessageElement) {
    errorMessageElement.textContent = err.message || 'An unknown error occurred during startup.';
    errorContainer.classList.remove('hidden');
  }
});
